import { Component } from "@angular/core";
import { NavController} from '@ionic/angular';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import { Router } from "@angular/router";
@Component({
    selector: 'score-board-einzel',
    templateUrl: 'score-board-einzel.html',
    styleUrls:['./score-board-einzel.scss']
  })
 export class ScoreBoardEinzel {
    scoreBoardArray: any = [];
    routeState:any;


    constructor(private navCtrl: NavController, 
                private router:Router,
                private storageProvider: StorageProvider
    ) {
        const nav = this.router.getCurrentNavigation();
        this.routeState = nav?.extras?.state || {};
         this.getScoreBoardData();
    }

    async getScoreBoardData() {
        // await this.storageProvider.getSaved('score-board-einzel').then((data) => this.scoreBoardArray = data);
        this.scoreBoardArray = this.scoreBoardArray.concat(this.routeState['array']);
        console.log("athletes einzel score"+JSON.stringify(this.scoreBoardArray));
    }

    displayEinzelTimer(ath) {
        let i = this.scoreBoardArray.findIndex(i => i.bibNo == ath.bibNo);
        if(i >= 0){
            return this.transform(this.scoreBoardArray[i].time);
        }
        else{
            return this.transform(0);
        }
    }

    transform(value: number): string {
        var sec_num = value; 
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num % 60;
        
        if (minutes > 60) { 
            hours++;
        };
        if (seconds > 60) { 
            minutes++;
        }; 
        
        if(hours < 10 && minutes < 10 && seconds < 10 ){
            return '0' + hours + ':' + '0' + minutes + ':' + '0' + seconds;
        }
        else if (hours < 10 && minutes < 10) {
            return '0' + hours + ':' + '0' + minutes + ':' + seconds;
        }
        else if (hours < 10 ) {
            return '0' + hours + ':' + minutes + ':' + seconds;
        }
        return '0'
    }

    onBackMenu() {
        this.navCtrl.pop();
    }
 }